// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ffeeef30","703":"53f61cd3","787":"5292edc5"}[chunkId] + ".chunk.js";
};